import styled from 'styled-components';

const Background = styled.div`
  background-image: ${({ image }) => `url(${image})`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  transform: translateY(-10px);
  height: ${({ height = 'calc(90vh)' }) => height};
`;

export default Background;
